import type { FC } from 'react';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import DownloadRounded from '@mui/icons-material/DownloadRounded';
import { Button } from '@mui/material';

import { OnDemandReportsDownloadContextProvider } from 'src/components/dashboard/DashboardPage/components/ButtonReportModal/contexts/onDemandReportsDownloadContext';

import DownloadModalDialog from './components/DownloadModalDialog';

export const BUTTON_FOLLOW_UP_DOWNLOAD_MODAL_BUTTON_TEST_ID =
  'follow-up-download-button';

const ButtonFollowUpDownloadModal: FC = () => {
  const { t } = useTranslation(['followUp', 'downloadManager']);

  const [showModal, setShowModal] = useState(false);

  return (
    <OnDemandReportsDownloadContextProvider>
      <Button
        variant="cta"
        color="primary"
        startIcon={<DownloadRounded />}
        onClick={() => setShowModal(true)}
        data-testid={BUTTON_FOLLOW_UP_DOWNLOAD_MODAL_BUTTON_TEST_ID}
      >
        {t('common:download')}
      </Button>
      <DownloadModalDialog
        showModal={showModal}
        closeDialog={() => setShowModal(false)}
        onDownload={() => {
          setShowModal(false);
        }}
      />
    </OnDemandReportsDownloadContextProvider>
  );
};

export default ButtonFollowUpDownloadModal;
